<div class="row mt-5">
    <div class="col-lg-6">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">My User Profile</h4>
                <h5 class="card-subtitle">Settings</h5>
                <div class="d-flex">
                    <h5 class="mr-2">Role:</h5>
                    <p class="item-role">{{ getRoleName(usuario.role) }}</p>
                </div>

                <!-- ****Formulario para actualizar el Perfil de Usuario -->

                <form class="form p-t-20" [formGroup]="perfilForm" (submit)="actualizarPerfil()"
                    *ngIf="watchFormProfile">

                    <div class="form-group">
                        <label for="perfilName" class="label">User name</label>
                        <div class="input-group">
                            <div class="input-group-addon"><i class="ti-user"></i></div>
                            <input id="perfilName" type="text" class="form-control"
                                placeholder="Nombre del Usuario" formControlName="name" toUppercase>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="perfilEmail" class="label">Email address</label>
                        <div class="input-group">
                            <div class="input-group-addon"><i class="ti-email"></i></div>
                            <input id="perfilEmail" type="email" class="form-control"
                                placeholder="Correo del Usuario" formControlName="email" [readOnly]="usuario.google"
                                toUppercase>
                        </div>
                    </div>
                    <div *ngIf="watchFormProfile">
                        <button type="submit" class="btn btn-themecolor waves-effect waves-light m-r-10"
                            [disabled]="perfilForm.invalid">
                            <i class="fa fa-save"></i>
                            Save
                        </button>
                        <button type="button" class="tap-option" (click)="watchForms()">Updated password</button>

                    </div>
                </form>
                <form class="form p-t-20" [formGroup]="formUpdatePassword" *ngIf="watchFormPassword"
                    (submit)="updatePassword()">
                    <div class="form-group">
                        <label for="perfilPassword" class="label">Password</label>
                        <div class="input-group">
                            <div class="input-group-addon"><i class="ti-key"></i></div>
                            <input id="perfilPassword" type="password" class="form-control" placeholder="Password"
                                formControlName="password">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="perfilPasswordRepeat" class="label">Repeat password</label>
                        <div class="input-group">
                            <div class="input-group-addon"><i class="ti-key"></i></div>
                            <input id="perfilPasswordRepeat" type="password" class="form-control"
                                placeholder="Repeat password" formControlName="passwordRepeat">
                        </div>
                        <small *ngIf="passwordNoValid" class="text-danger animated fadeIn">Password different</small>

                    </div>
                    <div *ngIf="watchFormPassword">
                        <button type="submit" class="btn btn-themecolor waves-effect waves-light m-r-10"
                            [disabled]="formUpdatePassword.invalid">
                            <i class="fa fa-save"></i>
                            Updated password
                        </button>
                        <button type="button" class="tap-option" (click)="watchForms()">Updated user</button>

                    </div>
                </form>
            </div>
        </div>
    </div>


    <div class="col-lg-6">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Perfil</h4>
                <h5 class="card-subtitle">User Image</h5>
                <div class="text-center">
                    <img *ngIf="!imgTemp" [src]="usuario.imagenUrl" width="250">
                    <img *ngIf="imgTemp" [src]="imgTemp" width="250">
                </div>
                <input class="mb-2" type="file" (change)="cambiarImagen($event.target.files[0])">

                <button type="button" class="btn btn-themecolor btn-block waves-effect waves-light m-r-10"
                    [disabled]="!imagenSubir" (click)="subirImagen()">
                    <i class="fa fa-save"></i>
                    Update Image
                </button>
            </div>
        </div>
    </div>


</div>


<div class="row">
    <div class="col-lg-6">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Signature</h4>
                <div class="row mr-1">
                    <div class="col border border-ligth rounded-3 bg-light text-center">
                        <br>
                        <signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart()"
                            (drawEnd)="drawComplete()"></signature-pad>
                        <br>
                        <button type="button" class="btn btn-themecolor mr-3" (click)="actualizarPerfil()">Save
                            Signature</button>
                        <button type="button" class="border-0" (click)="clearPad()">Reset</button>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <div class="col-lg-6" *ngIf="usuario.signature">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Registered signature</h4>
                <h5 class="card-subtitle">{{usuario.signature_date | date}}</h5>
                <div class="text-center mb-3">
                    <img [src]="usuario.signature" width="250">

                </div>
                <br>
                <br>





            </div>
        </div>
    </div>


</div>

<br>
<br>
<br>